import { UI_DetailCard } from 'ui/components/2-molecules/Card/DetailCard/DetailCard';
import { DynamicModule } from '1-project/DynamicModule/DynamicModule';
import { GoToTopNavigation } from '2-feature/Navgation/GoToTopNavigation';
import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import Head from 'next/head';
import { MainRegion } from '1-project/MainRegion/MainRegion';
import { formatDate } from '3-foundation/Localization/formatDate';
import { useRouter } from 'next/router';

interface Props extends Content.Page {
	properties: Content.EventPageProperties;
}

export const EventPage = ({ properties }: Props) => {
	const { eventStartDate, eventEndDate, eventLocation, eventStatus, eventPrice, eventSignupLink, pageHeader, pageSections } = properties ?? {};
	const dictionary = useDictionaryContext();
	const { locale } = useRouter();
	const eventStartDateDisplay = formatDate({ dateInput: eventStartDate, locale: locale });
	const eventEndDateDisplay = eventEndDate ? formatDate({ dateInput: eventEndDate, locale: locale }) : null;

	const dateText = `${eventStartDateDisplay} ${eventEndDateDisplay ? '- ' + eventEndDateDisplay : ''}`;
	const details = [
		{
			heading: dictionary.getEvent('Date'),
			text: dateText,
		},
		...(eventStatus ? [{ heading: dictionary.getEvent('Status'), text: eventStatus }] : []),
		{ heading: dictionary.getEvent('Location'), text: eventLocation },
		...(eventPrice ? [{ heading: dictionary.getEvent('Price'), text: eventPrice }] : []),
	];

	return (
		<>
			<Head>
				<meta name="search-date" content={dateText} />
				<meta name="search-location" content={eventLocation} />
				<meta name="search-price" content={eventPrice} />
				<meta
					name="search-end-date"
					content={
						eventEndDate ? formatDate({ dateInput: eventEndDate, mode: 'sort' }) : formatDate({ dateInput: eventStartDate, mode: 'sort' })
					}
				/>
				<meta name="search-sort" content={formatDate({ dateInput: eventStartDate, mode: 'sort' })} />
			</Head>
			<MainRegion
				header={pageHeader.map((headerModule, index) => (
					<DynamicModule key={index} module={headerModule} />
				))}
			>
				<UI_DetailCard items={details} cta={{ url: eventSignupLink?.url, target: eventSignupLink?.target, name: eventSignupLink?.name }} />
				<UI_Container width="Small">
					{pageSections.map((sectionModule, index) => (
						<DynamicModule key={index} module={sectionModule} />
					))}
				</UI_Container>
				<GoToTopNavigation />
			</MainRegion>
		</>
	);
};
